import axios from 'axios'
import { useSession } from 'next-auth/react'

import { BCKS_SESSION_STORAGE_KEY } from 'configs/auth'

import { Session } from 'types/auth'

const EVENT_NAME = 'guru_ksps_fe_user_action_v3'

export type TrackerAttributeValue = string | number | boolean

export interface TrackerAttributesV3 {
  [key: string]: TrackerAttributeValue
}

interface TrackerParamsV3 {
  event_name: string
  event_version?: number
  user_agent?: string
  attributes?: TrackerAttributesV3
}

const getDefaultData = () => {
  const bcksUserSession: Session = JSON.parse(
    window.localStorage.getItem(BCKS_SESSION_STORAGE_KEY)
  )

  return {
    id: crypto.randomUUID(),
    user_id: bcksUserSession?.user?.id,
    session_id: bcksUserSession?.sessionId,
    timestamp: new Date().toISOString(),
    email: bcksUserSession?.user?.email,
    event_version: 3,
    os: 'unknown',
    application_version: 'unknown',
    screen_name: 'unknown',
    device_id: 'unknown',
    platform: 'unknown',
    user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
  }
}

const mapAttributes = (attributes?: TrackerAttributesV3) => {
  if (!attributes) return undefined

  return Object.entries(attributes).map(([key, value]) => ({
    key,
    value: {
      int_value:
        typeof value === 'number' && Number.isInteger(value) ? value : null,
      double_value:
        typeof value === 'number' && !Number.isInteger(value) ? value : null,
      string_value: typeof value === 'string' ? value : null,
      bool_value: typeof value === 'boolean' ? value : null,
    },
  }))
}

export const useTrackerV3 = () => {
  const session = useSession()

  const satuEventTrack = (params?: TrackerParamsV3) => {
    const { attributes, ...rest } = params ?? {}

    const requestBody = {
      event_name: EVENT_NAME,
      data: JSON.stringify({
        ...getDefaultData(),
        ...rest,
        ...(attributes ? { attributes: mapAttributes(attributes) } : {}),
      }),
    }

    if (session.data?.satuEventUrl) {
      axios
        .post(session.data.satuEventUrl, requestBody, {
          headers: {
            'Content-Type': 'application/json',
          },
          auth: {
            username: session.data.satuEventUsername as string,
            password: session.data.satuEventPassword as string,
          },
        })
        .catch((error) => {
          console.error(error)
        })
    }
  }

  return {
    satuEventTrack,
  }
}
